import { DirtyRepliersListingStyle } from '../../types/repliers/UnsanitizedRepliersListingStyle';
import { RepliersListingStyle } from '../../types/repliers/RepliersListingStyle';
import { RepliersListing } from '../../types/repliers/RepliersListing';

export default function sanitizeRepliersStyle(
  repliersListing: RepliersListing,
): RepliersListingStyle | null {
  const { style } = repliersListing.details;

  if (!style) {
    return null;
  }

  switch (style) {
    case DirtyRepliersListingStyle.BungalowRaisedITSO:
      return RepliersListingStyle.BungalowRaised;
    case DirtyRepliersListingStyle.Storey_1AndAHalfITSO:
      return RepliersListingStyle.Storey_1AndAHalf;
    case DirtyRepliersListingStyle.Storey_2ITSO:
      return RepliersListingStyle.Storey_2;
    case DirtyRepliersListingStyle.Storey_2ITSO2:
      return RepliersListingStyle.Storey_2;
    case DirtyRepliersListingStyle.Storey_2AndAHalfITSO:
      return RepliersListingStyle.Storey_2AndAHalf;
    case DirtyRepliersListingStyle.Storey_3ITSO:
      return RepliersListingStyle.Storey_3;
    case DirtyRepliersListingStyle.StackedTownhouseITSO:
      return RepliersListingStyle.StackedTownhouse;
    case DirtyRepliersListingStyle.MultiLevelITSO:
      return RepliersListingStyle.MultiLevel;
  }

  return style as RepliersListingStyle;
}
